// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { FacilityRow } from '../../api/client'
import type { SearchableOption } from '../../components/common/SearchableSelect'

type FacilityAddress = Pick<FacilityRow, 'id' | 'name' | 'address_line' | 'city' | 'state_code' | 'zip_code'>

/** "12 Oak St, Springfield, IL 62701", leaving out the parts the directory doesn't have. */
export function facilityAddress(f: FacilityAddress): string {
  const stateZip = [f.state_code, f.zip_code].filter(Boolean).join(' ')
  return [f.address_line, f.city, stateZip].map(s => (s ?? '').trim()).filter(Boolean).join(', ')
}

/**
 * A facility in the enrollment picker shows its address while choosing (ASP 2026-10-14 #3): nursing
 * homes share names across towns, and staff pick by street. The address is the option's hint, which
 * the picker also searches, so typing part of the street finds the facility.
 */
export function facilityOption(f: FacilityAddress): SearchableOption {
  const address = facilityAddress(f)
  return address ? { value: f.id, label: f.name, hint: address } : { value: f.id, label: f.name }
}
